<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{ message }}</p>

  @for (error of errors; track error) {
    <p class="{{ (status==true?'success':'errors') }}"> {{ error }} </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="cancel-popup blue-color" mat-button (click)="cancel()">No</button>
  <button class="popup-save red-color" mat-button (click)="confirm()" cdkFocusInitial>
    @if (processing) {
      <mat-icon>
        <mat-spinner  diameter="20"></mat-spinner>
      </mat-icon>
    }
    Yes
  </button>
</mat-dialog-actions>
